import React from 'react';

export const ZapIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '12'}
    height={props?.height || '12'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 2L4.094 12.688c-.348.418-.523.628-.526.804a.5.5 0 0 0 .186.396c.137.112.41.112.957.112H12l-1 8 8.906-10.688c.348-.418.523-.628.526-.804a.5.5 0 0 0-.186-.396c-.137-.112-.41-.112-.957-.112H12l1-8z"
      stroke={props?.color || '#5183EB'}
      strokeWidth={props?.strokeWidth || '2'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ZapIcon;
